export const topAttractions = [
  {
    destination: 'Niagara Falls',
    img: 'https://cdn.getyourguide.com/img/location_img-283-3154886959-87.jpg',
    activitiesCount: 21,
    url: '/dicovery/niagara-falls',
  },
  {
    destination: 'Palace of Versailles',
    img: 'https://cdn.getyourguide.com/img/location_img-317-920812890-87.jpg',
    activitiesCount: 74,
    url: '/dicovery/palace-of-versailles',
  },
  {
    destination: 'Grand Canyon',
    img: 'https://cdn.getyourguide.com/img/location_img-489-2532435674-87.jpg',
    activitiesCount: 82,
    url: '/dicovery/grand-canyion',
  },
  {
    destination: 'Stonehenge',
    img: 'https://cdn.getyourguide.com/img/location_img-522-3494978632-87.jpg',
    activitiesCount: 76,
    url: '/dicovery/stonehenge',
  },
  {
    destination: 'Neuschwanstein Castle',
    img: 'https://cdn.getyourguide.com/img/location_img-528-1277212470-87.jpg',
    activitiesCount: 13,
    url: '/dicovery/neuschwanstein-castle',
  },
  {
    destination: 'Keukenhof',
    img: 'https://cdn.getyourguide.com/img/location_img-530-898418392-87.jpg',
    activitiesCount: 30,
    url: '/dicovery/keukenhof',
  },
  {
    destination: 'Alcatraz',
    img: 'https://cdn.getyourguide.com/img/location_img-535-1568828709-87.jpg',
    activitiesCount: 39,
    url: '/dicovery/alcatraz',
  },
  {
    destination: 'Pompeii',
    img: 'https://cdn.getyourguide.com/img/location_img-685-1644697677-87.jpg',
    activitiesCount: 241,
    url: '/dicovery/pompeii',
  },
];
